// extracted by mini-css-extract-plugin
export default {"perks":"Perks_perks__0XJl-","h1":"Perks_h1__ZO4iQ","ul":"Perks_ul__mHCF6","svg":"Perks_svg__ifMzx"};